const ACTION_ITEMS = {
  USER_ALERTS: {
    GET: 'USER_ALERTS_FETCH',
    CLEAR: 'USER_ALERTS_CLEAR',
  },
};

export default ACTION_ITEMS;
